import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component } from '@angular/core';

@Component({
  selector: 'cng-agent-booking-chat-inprocess-conference',
  templateUrl: './agent-booking-chat-inprocess-conference.component.html',
})
export class AgentBookingChatInprocessConferenceComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);
  readonly isConf$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.IsConf.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
